<template>
  <div class="followup" :style="{paddingBottom:(is_doctor?'75px':'15px')}">
    <div class="personal_card">
      <p class="personal_p1" @click="openarchive">
        患者信息
        <span v-if="followupArr.age!=null&&followupArr.age!=''">{{followupArr.age}}</span>
        <span v-else>暂无</span>
        <span v-if="followupArr.sex==0">女</span>
        <span v-else>男</span>
        <span>{{followupArr.name}}</span>
      </p>
    </div>
    <div class="feedback">
      <p class="feedback_title">病情反馈</p>
      <p class="feedback_p1 mt25">
        病情变化：
        <span>{{followupArr.body_feeling}}</span>
      </p>
      <p class="feedback_p1">
        已改善方面：
        <span v-if="followupArr.improved!=null">{{followupArr.improved}}</span>
        <span v-else>未填写</span>
      </p>
      <p class="feedback_p1">
        未改善方面：
        <span v-if="followupArr.no_improve!=null">{{followupArr.no_improve}}</span>
        <span v-else>未填写</span>
      </p>
      <p class="feedback_p1">
        新增症状：
        <span v-if="followupArr.new_symptoms!=null">{{followupArr.new_symptoms}}</span>
        <span v-else>未填写</span>
      </p>
      <p
        class="feedback_p1 mt25"
        v-if="followupArr.furred_tongue_url!=''||followupArr.tongue_base_url!=''"
      >舌象照片：</p>
      <p
        class="feedback_p2"
        v-if="followupArr.furred_tongue_url!=''||followupArr.tongue_base_url!=''"
      >
        <img
          v-if="followupArr.furred_tongue_url!=''"
          :src="followupArr.furred_tongue_url"
          @click="sceneImg(followupArr.furred_tongue_url)"
          alt
        />
        <img
          v-if="followupArr.tongue_base_url!=''"
          :src="followupArr.tongue_base_url"
          @click="sceneImg(followupArr.tongue_base_url)"
          alt
        />
      </p>
      <p class="feedback_p1 mt25" v-if="followupArr.diagnose_url!=''">本次治疗后的相关检查报告：</p>
      <p class="feedback_p2" v-if="followupArr.diagnose_url!=''">
        <img :src="followupArr.diagnose_url" @click="sceneImg(followupArr.diagnose_url)" alt />
      </p>
      <p class="feedback_p3">{{distance(followupArr.updated_at)}}</p>
    </div>
    <!-- evaluate -->
    <div class="evaluate_content mr20">
      <p class="evaluate_title">本次诊疗体验</p>
      <!-- {{followupArr.response_speed-1}} -->
      <p
        v-for="(item,index) in diagnosisArr"
        :key="index"
        v-if="(followupArr.diagnosis_experience-1)==index"
        :class="index==(followupArr.diagnosis_experience-1)?'response_active response_active_'+index:''"
      >
        <span :class="'content2_img_'+index"></span>
        {{item}}
      </p>
    </div>
    <div class="evaluate_content">
      <p class="evaluate_title">医生回复速度</p>
      <!-- {{followupArr.response_speed-1}} -->
      <p
        v-for="(item,index) in responseArr"
        :key="index"
        v-if="(followupArr.response_speed-1)==index"
        :class="index==(followupArr.response_speed-1)?'response_active response_active_'+index:''"
      >
        <span :class="'content2_img_'+index"></span>
        {{item}}
      </p>

    </div>
    <div class="sunmit_content" v-show="is_doctor">
      <button class="submit" v-show="is_doctor" @click="prescription">开方</button>
    </div>
    <Loading :value="show"/>
  </div>
</template>
<script>
// import http from "../../util/upload";
// import md5 from "js-md5";
import Loading from '../loading/loading'
import { ImagePreview } from "vant";
import http from "../../util/iapetusApiConfig";
import { deviceType } from "../../util/deviceType";
export default {
  components: {
    Loading
  },
  data() {
    return {
      show:true,
      followupArr: {
        name: "",
        sex: 0,
        age: 18,
        height: 160,
        weight: 56,
        allergy_history:
          "",
        medical_history: "",
        body_feeling: "",
        improved: "",
        no_improve: "",
        new_symptoms: null,
        furred_tongue_url:
          "",
        tongue_base_url: "",
        diagnose_url: "",
        response_speed: 2,
        diagnosis_experience: 3,
        created_at: 1600741434,
      },
      responseArr: ["回复迅速", "回复较快", "回复较慢", "回复很慢"],
      diagnosisArr: ["非常满意", "满意", "一般", "需要改善"],
      visit_sheet_id: null,
      is_doctor: true,
      doctor_id: null,
      user_id: null,
      isApp:"",
    };
  },
  created() {
    console.log(this.$route.query)
    let bridge = window.WebViewJavascriptBridge;
    this.isApp = this.$appUtils.isApp();
    if(this.isApp == "IOS"){
      bridge.callHandler("getUserInfo", "", (response) => {
        this.user_id = response.user_id;
        this.doctor_id = response.doctor_id;
        this.token = response.token;
      });
    }else  if (this.isApp == "android") {
      var user_info = this.$appUtils.appData();
      if (user_info) {
        this.user_id = user_info.user_id;
        this.doctor_id = user_info.doctor_id;
        this.token = user_info.token;
      }
    } else if (this.$route.query.is_mini) {
      this.token = this.$route.query.token
      this.doctor_id = this.$route.query.doctor_id
      this.user_id = this.$route.query.user_id
      this.platform_type ='1';
    }else if (this.$route.query.is_baoan) {
      this.token = this.$route.query.token
      this.doctor_id = this.$route.query.doctor_id
      this.user_id = this.$route.query.doctor_user_id
      this.platform_type ='1';
    }else if (this.$route.query.is_baoanZ) {
      console.log('1221e21321')
      this.token = this.$route.query.token
      this.doctor_id = this.$route.query.doctor_id
      this.user_id = this.$route.query.user_id
      this.platform_type ='2';
      this.is_doctor = true;
    }else {
      this.user_id = localStorage.getItem('user_id');
      this.token = localStorage.getItem('token');
      this.platform_type ='1';
    }
    if (deviceType.isDoctor) {
      this.is_doctor = true;
      this.user_id = this.$route.query.user_id;
    } else if(this.$route.query.is_baoanZ){
      this.is_doctor = true;
    }else {
      this.is_doctor = false
    }
    var listid = this.$route.query.visit_sheet_id;
    if (listid) {
      this.visit_sheet_id = listid;
    }
    setTimeout(()=>{
      this.loadinit()
    }, 1000);
  },
  methods: {
    openarchive(){
      this.$appUtils.appOpenArchive({'archive_id':this.archive_id});
    },
    prescription() {
      let params = {
        user_id: this.user_id,
        name: this.followupArr.name,
        sex: this.followupArr.sex,
        age: this.followupArr.age,
      };
      let bridge = window.WebViewJavascriptBridge;
      if(this.isApp == "IOS"){
        bridge.callHandler("sendPrescription", params, (response) => {

        });
      }else{
        this.$appUtils.appSendPrescription(params);

      }
    },
    sceneImg(images) {
      ImagePreview([images]);
    },
    loadinit() {
      let that = this;
      let url = "";
      console.log(this.doctor_id,' this.doctor_id')
      if (this.is_doctor) {
        console.log(' this.doctor_id')
        url =
          "studio/doctors/" +
          this.doctor_id +
          "/visit_sheets/" +
          this.visit_sheet_id+'?platform_type='+this.platform_type;
      } else {
        url = "users/" + this.user_id + "/visit_sheets/" + this.visit_sheet_id+'?platform_type='+this.platform_type;
      }
      http
        .get(url, {
          headers: {
            "Content-Type": "application/json",
            Authorization: this.token,
          },
        })
        .then(function (res) {
          that.show = false
          if (res.data.status_code == 200) {
            that.followupArr = res.data.data;
            if(that.isApp != 'IOS'){
            that.$appUtils.appCloseLoadingView();
            }
          }
        });
    },
    distance(day) {
      //过去的时间戳
      var now = new Date(day * 1000); //过去 //年
      var year = now.getFullYear(); //月
      var month = now.getMonth() + 1; //日
      var date = now.getDate(); //时
      var hour = now.getHours(); //分
      var minute = now.getMinutes(); //秒
      var second = now.getSeconds();
      if (month < 10) {
        month = "0" + month;
      }
      if (date < 10) {
        date = "0" + date;
      }
      if (hour < 10) {
        hour = "0" + hour;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (second < 10) {
        second = "0" + second;
      }
      var timer =
        year + "年" + month + "月" + date + "日 " + hour + ":" + minute;

      return timer;
    },
  },
};
</script>
<style lang="scss" scoped>
.followup {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 15px 75px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #333;
  .personal_card {
    width: 100%;
    height: 45px;
    background: linear-gradient(90deg, #ac4c38 0%, #db715c 100%);
    box-shadow: 1px 4px 9px 3px rgba(35, 25, 21, 0.15);
    border-radius: 10px;
    color: #fff;
    box-sizing: border-box;
    padding: 15px 10px;
    .personal_p1 {
      font-size: 16px;
      line-height: 15px;
      font-weight: bold;
      padding-right: 16px;
      span {
        font-size: 15px;
        font-weight: 500;
        margin-left: 15px;
        float: right;
      }
    }
  }
  .feedback {
    width: 100%;
    background: #ffffff;
    box-shadow: 1px 2px 5px 2px rgba(35, 25, 21, 0.15);
    border-radius: 10px;
    margin-top: 10px;
    box-sizing: border-box;
    padding: 20px 10px;
    .feedback_title {
      font-family: PingFang SC;
      font-weight: bold;
      color: #333333;
    }
    .feedback_p1 {
      margin-top: 10px;
      font-size: 15px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #666666;
      span {
        color: #333333;
      }
    }
    .feedback_p2 {
      margin-top: 10px;
      img {
        width: 60px;
        height: 60px;
        border-radius: 5px;
        margin-right: 10px;
      }
    }
    .feedback_p3 {
      margin-top: 30px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 500;
      color: #666666;
    }
  }
  .evaluate_content {
    width: calc(50% - 12px);
    height: 146px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 3px 3px 12px 0px rgba(0, 0, 0, 0.08);
    border: 1px solid transparent;
    border-radius: 8px;
    display: inline-block;
    margin-top: 24px;
    .evaluate_title {
      text-align: center;
      font-family: PingFang-SC-Bold, PingFang-SC;
      font-weight: bold;
      margin-top: 15px;
      margin-bottom: 20px;
    }
    .response_active {
      color: #ac4b38;
      margin: 0 auto;
      width: fit-content;
      text-align: center;
      font-size: 12px;
      span {
        display: block;
        width: 48px;
        height: 48px;
        background-size: cover;
        margin-bottom: 4px;
      }
    }
    .content2_img_0 {
      background-image: url("../../assets/images/evaluate/expression1_nor.png");
    }
    .content2_img_1 {
      background-image: url("../../assets/images/evaluate/expression2_nor.png");
    }
    .content2_img_2 {
      background-image: url("../../assets/images/evaluate/expression3_nor.png");
    }
    .content2_img_3 {
      background-image: url("../../assets/images/evaluate/expression4_nor.png");
    }
    .response_active_0 span {
      background-image: url("../../assets/images/evaluate/expression1_pre.png");
    }
    .response_active_1 span {
      background-image: url("../../assets/images/evaluate/expression2_pre.png");
    }
    .response_active_2 span {
      background-image: url("../../assets/images/evaluate/expression3_pre.png");
    }
    .response_active_3 span {
      background-image: url("../../assets/images/evaluate/expression4_pre.png");
    }
  }
  .mr20 {
    margin-right: 15px;
  }
  .mt25 {
    margin-top: 25px !important;
  }
  .sunmit_content {
    width: 100%;
    padding: 8px 0px;
    position: fixed;
    bottom: 0px;
    left: 0px;
    background: #fff;
    // box-shadow: 0px 1px 0px 0px rgba(228, 228, 228, 1);
    border-top: 1px solid #e4e4e4;
    .submit {
      display: block;
      width: calc(100% - 40px);
      height: 48px;
      background: rgba(172, 75, 56, 1);
      border-radius: 10px;
      font-size: 18px;
      color: #fff;
      border: none;
      margin: 0 auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/followup/followup_detail.vue